import App from './App.svelte';

const app = new App({
	target: document.getElementById('builder-container'),
	props: {
		name: 'world'
	}
});

export default app;
